import { Feature } from "./feature.types";

interface FeatureCardProps {
  feature: Feature;
  index: number;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ feature }) => (
  // <div className="bg-white p-8 rounded-2xl shadow-lg hover:transform hover:-translate-y-2 hover:shadow-xl transition-all duration-300 text-center">
  // bg-gradient-to-br from-orange-50 to-amber-50 p-6 rounded-xl hover:shadow-lg transition
  <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-8 rounded-2xl shadow-lg hover:transform hover:-translate-y-2 hover:shadow-xl transition-all duration-300 text-center">
    {/* <div className="text-4xl mb-4 bg-gradient-to-r from-indigo-600 to-purple-600 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto"> */}
    <div className="text-4xl mb-4 bg-orange-500 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto">
      {feature.icon}
    </div>
    <h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
    <p className="text-gray-600">{feature.description}</p>
  </div>
);

export default FeatureCard;